'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iBem = require('../i-bem/i-bem.react');

var _eRadio = (require('./__radio/radiobox__radio.react.js').default || require('./__radio/radiobox__radio.react.js')).applyDecls();

var _eRadio2 = _interopRequireDefault(_eRadio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.decl)({
    block: 'radiobox',
    tag: 'span',
    willInit: function willInit() {
        this.__base.apply(this, arguments);

        this.onChange = this.onChange.bind(this);
    },
    attrs: function attrs(_ref) {
        var _attrs = _ref.attrs;

        return _extends({}, _attrs);
    },
    mods: function mods(_ref2) {
        var theme = _ref2.theme,
            size = _ref2.size,
            view = _ref2.view,
            tone = _ref2.tone;

        return { theme: theme, size: size, view: view, tone: tone };
    },
    content: function content(_ref3) {
        var _this = this;

        var mainDisabled = _ref3.disabled,
            mainValue = _ref3.value,
            name = _ref3.name,
            children = _ref3.children;

        return _react.Children.map(children, function (item, key) {
            return typeof item.type === 'function' ? (0, _react.cloneElement)(item, {
                name: name,
                key: key,
                mainValue: mainValue,
                mainDisabled: mainDisabled,
                onChange: mainDisabled ? undefined : _this.onChange
            }) : item;
        });
    },
    onChange: function onChange(e) {
        this.props.onChange && this.props.onChange(e);
    }
}, {
    Radio: _eRadio2.default,
    propTypes: {
        theme: _propTypes2.default.string,
        size: _propTypes2.default.string,
        view: _propTypes2.default.oneOf(['classic', 'default']),
        tone: _propTypes2.default.string,
        disabled: _propTypes2.default.bool,
        value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
    },
    defaultProps: {
        view: 'classic'
    }
});